<template>
  <section class="container-fluid image-bg py-6 py-md-8" id="transaction-hero">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
        <h1 class="white-text text-md-center mb-3 load-anim" ref="headline">
          Representative Transactions
        </h1>
        <h2
          class="subhead gold-text text-md-center mb-5 load-anim"
          ref="subhead"
        >
          A Proven Track Record of Success
        </h2>
        <p class="mb-6 load-anim" ref="content">
          CS Capital Advisors provides corporate advisory, mergers &
          acquisitions, capital raising and restructuring services to the health
          care, hospitality and other commercial real estate industries and
          related service sectors.
        </p>
        <a
          id="explore-link"
          class="btn -hollow_white load-anim"
          href="#transactions"
          ref="button"
          @click.prevent="scrollLink"
          >Explore</a
        >
      </div>
    </div>
  </section>
</template>

<script>
import { TimelineLite, TweenLite, Power2 } from "gsap";
// eslint-disable-next-line no-unused-vars
import ScrollToPlugin from "gsap/ScrollToPlugin";
export default {
  methods: {
    scrollLink() {
      var yVal = document.getElementById("transactions").offsetTop;
      TweenLite.to(window, 1, {
        scrollTo: { y: yVal, autoKill: false },
        ease: Power2.easeOut
      });
    },
    introAnim() {
      var introAnimEls = [];
      introAnimEls.push(this.$refs.headline);
      introAnimEls.push(this.$refs.subhead);
      introAnimEls.push(this.$refs.content);
      introAnimEls.push(this.$refs.button);
      var t1 = new TimelineLite();
      t1.staggerTo(
        introAnimEls,
        1,
        { opacity: 1, transform: "translateY(0)", ease: Power2.easeOut },
        0.3,
        "-=0.2"
      );
    }
  },
  mounted() {
    this.introAnim();
  }
};
</script>

<style lang="scss" scoped>
#transaction-hero {
  background-image: url(../assets/hp-transaction-bg.jpg);
  p {
    color: #ffffff;
  }
}
</style>
